import React, { useEffect, useState } from 'react'

// Custom components
import Card from '../Card'

// Styling
import './MainPageContent.css'

import articles from '../../data/articles.json'

export const MainPageContent = () => {

  const [myData, setMyData] = useState([])

  // getData performs api call with fetch function
  const getData = async () => {
    // FIXME: Removed 040123 to contain articles internally
    // const response = await fetch('https://articlesapi.wordpay.dev/api/v1/articles')
    // const data = await response.json()
    const data = articles
    setMyData(data.payload)
  }

  // API call in useEffect
  useEffect(() => {
    getData().catch(err => console.log('ERR: ', err))
  }, [])
  
  return (
    <div className='wordpay-demo__main-content-all'>
      {myData.length > 0 ? myData.map((article)=> 
      <Card key={article._id} title={article.title} cssClass="wordpay-demo__main-content-all-card" titleSectionClass='wordpay-demo__card-article-title-section' titleClass='wordpay-demo__card-article-title'
      subtitleClass='wordpay-demo__card-article-subtitle' subtitle={article.lead} isSingleArticle={true} addressId={article._id}/>
      ) : 
        <>
          <Card cssClass="wordpay-demo__card--loading" isLoading={true} />
          <Card cssClass="wordpay-demo__card--loading" isLoading={true} />
          <Card cssClass="wordpay-demo__card--loading" isLoading={true} />
          <Card cssClass="wordpay-demo__card--loading" isLoading={true} />
          <Card cssClass="wordpay-demo__card--loading" isLoading={true} />
          <Card cssClass="wordpay-demo__card--loading" isLoading={true} />
          <Card cssClass="wordpay-demo__card--loading" isLoading={true} />
        </>
      }
    </div>
  )
}
